import { useMemo } from 'react'
import {
  computeCollectionStatus,
  type CardLike,
  type CollectionStatus,
  type DeckLine,
} from '@/hooks/collections/collectionStatusCalc'
import { useCollectionQuantitiesByBase } from '@/hooks/collections/useCollectionQueries'
import { useAuthStore } from '@/store/authStore'

/**
 * Computes collection ownership status for a set of deck cards + leader.
 * Returns null when not authenticated or collection data isn't loaded.
 */
export function useCollectionStatus(cards: DeckLine[], leader: CardLike | null | undefined): CollectionStatus | null {
  const { isAuthenticated } = useAuthStore()
  const { data: collectionData } = useCollectionQuantitiesByBase()

  return useMemo(() => {
    if (!isAuthenticated || !collectionData?.quantitiesByBase || !leader) {
      return null
    }

    return computeCollectionStatus(collectionData.quantitiesByBase, [{ card: leader, quantity: 1 }, ...cards])
  }, [isAuthenticated, collectionData, cards, leader])
}
